import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from './DragHandle';
import { TableCell } from '@mui/material';
import { FC } from 'react';

interface IDraggableTableRow {
  row: any;
  disabledDnD: boolean;
}
export const DraggableTableRow: FC<IDraggableTableRow> = ({ row, disabledDnD }) => {
  const { attributes, listeners, transform, transition, setNodeRef, isDragging } = useSortable({
    id: row.original.id,
    disabled: disabledDnD,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
    backgroundColor: 'white',
  };

  return (
    <tr ref={setNodeRef} style={style} {...row.getRowProps()}>
      {isDragging ? (
        <TableCell colSpan={row.cells.length}>&nbsp;</TableCell>
      ) : (
        row.cells.map((cell: any, i: number) => {
          if (i === 0) {
            return (
              <TableCell style={{ whiteSpace: 'nowrap' }} {...cell.getCellProps()}>
                {disabledDnD ? null : <DragHandle {...attributes} {...listeners} />}
                <span>{cell.render('Cell')}</span>
              </TableCell>
            );
          }
          return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>;
        })
      )}
    </tr>
  );
};
